module.exports = __webpack_public_path__ + "static/img/Bachelor_010695.599e202.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010695.jpg
// module id = 221
// module chunks = 0